import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import EditRobotMapScreen from "../../_form/edit-map";

export default function EditRobotMapPage() {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  return (
    <Box>
      {id && (
        <EditRobotMapScreen
          robotMapId={id}
          onCancel={() => {
            // Handle cancel action
            navigate("/config/robot-maps", {
              replace: true
            })
          }}
          onSuccess={() => {
            navigate("/config/robot-maps", {
              replace: true,
              flushSync: true,
              state: { refresh: true }
            })
          }}
        />
      )}
    </Box>
  )
}